import React from "react";
import styled from "styled-components";

const StickyWrapper = styled.div`
  display: flex;
  margin: 0 auto;
  position: sticky;
  z-index: 1;
`;

const NavStickyWrapper = ({ children, className }) => {
  return <StickyWrapper className={className}>{children}</StickyWrapper>;
};

export default NavStickyWrapper;
